import React from 'react';
import { makeStyles } from 'design-system/styles';

const useStyles = makeStyles({
  td: {
    borderTop: '1px solid #e6e6e6',
    borderBottom: '1px solid #e6e6e6',
    padding: '10px 5px',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const QMTableFooter: React.FC<{
  currentCount: number;
  totalCount?: number;
  onLoadMore?: () => void;
}> = ({ currentCount, totalCount, onLoadMore }) => {
  const classes = useStyles();

  const handleLoadMore = (e: React.MouseEvent) => {
    if (!onLoadMore) {
      return;
    }
    onLoadMore();
    e.preventDefault();
    return false;
  };

  return (
    <tfoot>
      <tr>
        <td colSpan={100} className={classes.td}>
          <div className={classes.container}>
            <div>
              {onLoadMore && (!totalCount || currentCount < totalCount) && (
                <a href="#" onClick={handleLoadMore}>
                  Load More
                </a>
              )}
            </div>
            <span>
              Showing {currentCount} of {totalCount || 0}
            </span>
          </div>
        </td>
      </tr>
    </tfoot>
  );
};

export default QMTableFooter;
